import mapSimpleSubcategory from './mapSimpleSubcategory';

const mapSimpleCategory = ({ categoryTitle, subcategories }) => ({
  categoryTitle,
  subcategory: subcategories.map(mapSimpleSubcategory),
});

export default mapSimpleCategory;
